__turbopack_context__.v({
  "affiliation": "FDDsOW_affiliation",
  "bio": "FDDsOW_bio",
  "bio-text": "FDDsOW_bio-text",
  "bio-title": "FDDsOW_bio-title",
  "caption-badge": "FDDsOW_caption-badge",
  "degree": "FDDsOW_degree",
  "degree-icon": "FDDsOW_degree-icon",
  "hero-copy-cell": "FDDsOW_hero-copy-cell",
  "hero-grid": "FDDsOW_hero-grid",
  "hero-media-cell": "FDDsOW_hero-media-cell",
  "interest": "FDDsOW_interest",
  "interests": "FDDsOW_interests",
  "scroll-button": "FDDsOW_scroll-button",
  "social": "FDDsOW_social",
  "social-link": "FDDsOW_social-link",
  "title": "FDDsOW_title",
});
